export default __webpack_public_path__ + "static/media/contact--mobile@2x.71045afa.webp";